import { EventService, deepCopy } from "@perxis-auto/shared/lib";
import { isDefined } from "@perxis-auto/shared/lib/lib/is";
import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { actions } from "../slice.js";
import "../../../filterValues/model/middleware/index.js";
import "../../../filterValues/model/selectors/selectAllFilterValues.js";
import "../../../filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../filterValues/model/selectors/selectFilterImmutableValues.js";
import { selectFilterItemByKey } from "../../../filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../filterValues/model/selectors/selectFilterItems.js";
import "../../../filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../filterValues/model/selectors/selectIsFilterValuesMissing.js";
import "../../../../shared/config/env.js";
import { APP_EVENTS, APP_EVENT_BUTTON_IDS } from "../../../../shared/config/events.js";
import { NavigationService } from "../../../../shared/services/navigation/index.js";
import "@perxis-js/perxis-client/dist/items";
import "@perxis-js/perxis-client/dist/references";
import "nice-grpc-web";
import "@perxis-auto/shared";
import "abort-controller-x";
import "../../../../shared/lib/logger/index.js";
import "../../../../shared/store/config/middleware/index.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import { selectSort } from "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import { selectOffset } from "../../../../shared/store/pagination/model/selectors/selectOffset.js";
import { actions as actions$1 } from "../../../../shared/store/pagination/model/slice.js";
import { ConstructorWidgetEnum } from "../../../../shared/types/constructor/widget.js";
import { HistoryLocationActionEnum } from "../../../../shared/types/router.js";
import "../selectors/selectFilterHistory.js";
import { selectFilterSortValue } from "../selectors/selectFilterSortValue.js";
import "../selectors/selectFilterValuesCount.js";
import "../selectors/selectIsFilterValuesSelected.js";
import { selectIsInitialSortValuesSelected } from "../selectors/selectIsInitialSortValuesSelected.js";
import { selectIsValidSortValuesSelected } from "../selectors/selectIsValidSortValuesSelected.js";
import { selectSlugedFilterValues } from "../selectors/selectSlugedFilterValues.js";
const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  actionCreator: actions.setValues,
  effect: (action, listenerApi) => {
    const state = listenerApi.getState();
    const filterValuesChoice = state.filterChoice.values;
    const changedFilterValuesChoice = action.payload;
    for (const [filterKey, filterValue] of Object.entries(changedFilterValuesChoice)) {
      const filterItem = selectFilterItemByKey(state, {
        filterKey
      });
      if (!filterItem || isDefined(filterValue)) {
        continue;
      }
      if (!filterItem.dependents || !filterItem.dependents.length) {
        continue;
      }
      const resolvedFilters = filterItem.dependents.reduce(
        (acc, dependentFilterKey) => {
          const dependentFilterValue = filterValuesChoice == null ? void 0 : filterValuesChoice[dependentFilterKey];
          if (!isDefined(dependentFilterValue)) {
            return acc;
          }
          return {
            ...acc,
            [`${dependentFilterKey}`]: void 0
          };
        },
        {}
      );
      if (Object.keys(resolvedFilters).length) {
        listenerApi.dispatch(actions.setValues(resolvedFilters));
      }
    }
  }
});
listenerMiddleware.startListening({
  matcher: isAnyOf(actions.setValues, actions.setSort),
  effect: (action, listenerApi) => {
    const state = listenerApi.getState();
    const slugedFilterValues = selectSlugedFilterValues(state);
    const { enable: isSortEnable } = selectSort(state);
    const sort = selectFilterSortValue(state);
    const isInitialSortValuesSelected = selectIsInitialSortValuesSelected(state);
    const isValidSortValuesSelected = selectIsValidSortValuesSelected(state);
    const searchParams = new URLSearchParams(slugedFilterValues);
    if (isSortEnable && sort.length && isValidSortValuesSelected && !isInitialSortValuesSelected) {
      searchParams.set("sort", sort.toString());
    }
    const navigationAction = action.type === actions.setValues.type ? HistoryLocationActionEnum.SetFilters : HistoryLocationActionEnum.SetSort;
    NavigationService.getInstance().replace(
      {
        search: `?${searchParams.toString()}`.replaceAll("%2C", "|")
      },
      {
        action: navigationAction
      }
    );
  }
});
listenerMiddleware.startListening({
  actionCreator: actions$1.setOffset,
  effect: (action, listenerApi) => {
    const state = listenerApi.getState();
    const slugedFilterValues = selectSlugedFilterValues(state);
    const { enable: isSortEnable } = selectSort(state);
    const sort = selectFilterSortValue(state);
    const offset = selectOffset(state);
    const isInitialSortValuesSelected = selectIsInitialSortValuesSelected(state);
    const isValidSortValuesSelected = selectIsValidSortValuesSelected(state);
    const searchParams = new URLSearchParams(slugedFilterValues);
    if (offset) {
      searchParams.set("offset", offset.toString());
    }
    if (isSortEnable && sort.length && isValidSortValuesSelected && !isInitialSortValuesSelected) {
      searchParams.set("sort", sort.toString());
    }
    NavigationService.getInstance().replace(
      {
        search: `?${searchParams.toString()}`.replaceAll("%2C", "|")
      },
      {
        action: HistoryLocationActionEnum.SetOffset
      }
    );
  }
});
listenerMiddleware.startListening({
  actionCreator: actions.resetValues,
  effect: () => {
    NavigationService.getInstance().replace(
      {
        search: ""
      },
      {
        action: HistoryLocationActionEnum.ResetFilters
      }
    );
  }
});
listenerMiddleware.startListening({
  actionCreator: actions.setValues,
  effect: (action, listenerApi) => {
    const state = listenerApi.getState();
    const previousState = listenerApi.getOriginalState();
    const eventService = EventService.getInstance();
    const history = deepCopy(state.filterChoice.history);
    const previousFilters = previousState.filterChoice.values;
    const changedFilterValuesChoice = action.payload;
    const historyItemsToAdd = [];
    const historyItemsToRemove = [];
    const historyItemsToChange = [];
    for (const [filterKey, filterValue] of Object.entries(changedFilterValuesChoice)) {
      const filterItem = selectFilterItemByKey(state, {
        filterKey
      });
      if (!filterItem) {
        continue;
      }
      const previousFilterValue = previousFilters == null ? void 0 : previousFilters[filterKey];
      if (isDefined(filterValue) || isDefined(previousFilterValue)) {
        eventService.sendEvent(APP_EVENTS.FilterValueChanged, {
          filterKey,
          value: filterValue,
          previousState: previousFilterValue
        });
      }
      const filterHistoryItems = history.filter((historyItem) => historyItem.key === filterKey);
      const filterHistoryItemValues = filterHistoryItems.map(({ value }) => value);
      const isFilterRemoval = typeof filterValue === "undefined" || Array.isArray(filterValue) && !filterValue.length;
      if (isFilterRemoval) {
        historyItemsToRemove.push(...filterHistoryItems);
      } else {
        switch (filterItem.type) {
          case ConstructorWidgetEnum.FilterLocation:
          case ConstructorWidgetEnum.FilterSelect:
          case ConstructorWidgetEnum.FilterSlider:
          case ConstructorWidgetEnum.FilterMultipleSelect:
          case ConstructorWidgetEnum.FilterCheckboxGroup:
          case ConstructorWidgetEnum.FilterModels:
          case ConstructorWidgetEnum.FilterColorPicker:
          case ConstructorWidgetEnum.FilterDuoColorPicker: {
            const resolvedFilterValue = Array.isArray(filterValue) ? filterValue : [filterValue];
            historyItemsToRemove.push(
              ...filterHistoryItems.filter((historyItem) => !resolvedFilterValue.includes(historyItem.value))
            );
            historyItemsToAdd.push(
              ...resolvedFilterValue.filter((value) => !filterHistoryItemValues.includes(value)).map((value) => ({
                key: filterKey,
                value
              }))
            );
            break;
          }
          case ConstructorWidgetEnum.FilterRangeSlider: {
            if (!filterHistoryItems.length) {
              historyItemsToAdd.push({
                key: filterKey,
                value: filterValue
              });
            } else {
              historyItemsToChange.push({
                ...filterHistoryItems[0],
                value: filterValue
              });
            }
            break;
          }
        }
      }
    }
    const resolvedHistory = history.reduce((acc, historyItem) => {
      const historyItemToRemoveIndex = historyItemsToRemove.findIndex((i) => i === historyItem);
      if (historyItemToRemoveIndex !== -1) {
        return acc;
      }
      const historyItemToChangeIndex = historyItemsToChange.findIndex((i) => i.key === historyItem.key);
      if (historyItemToChangeIndex !== -1) {
        return [...acc, historyItemsToChange[historyItemToChangeIndex]];
      }
      return [...acc, historyItem];
    }, []).concat(...historyItemsToAdd);
    listenerApi.dispatch(actions.setHistory(resolvedHistory));
  }
});
listenerMiddleware.startListening({
  actionCreator: actions.resetValues,
  effect: (action, listenerApi) => {
    const eventService = EventService.getInstance();
    listenerApi.dispatch(actions.resetHistory());
    eventService.sendEvent(APP_EVENTS.ButtonClicked, { id: APP_EVENT_BUTTON_IDS.RESET_FILTERS });
  }
});
listenerMiddleware.startListening({
  actionCreator: actions.setValues,
  effect: (_, listenerApi) => {
    listenerApi.dispatch(actions$1.setOffset(0));
  }
});
const { middleware } = listenerMiddleware;
export {
  middleware
};
